export default "__VITE_ASSET__qT9_tfRM__"